

$(document).ready(function(){
	if($(window).width() <= 767){
			var ph=$('#search-inpt').attr('placeholder');

			$('#search-inpt').attr('placeholder','');
			$('#search_form input').click(function(){
				$('#search-inpt').focus();
				$('#search-inpt').attr('placeholder',ph);
				return false;
			})
			var startpos=0;
			var starttouch=0;
			var obj = $('#wrapper #menu #activesubmenu').get(0);
			    
			if(obj){
				var w=50;
				
				var left=0;
				$(obj).children().each(function(){
					if($(this).hasClass('active'))
					left=w;
						w+=$(this).width()+parseInt($(this).css('padding-left'))+parseInt($(this).css('margin-left'))+parseInt($(this).css('padding-right'))+parseInt($(this).css('margin-right'));
				})

				if(left)
					if(w>$(window).width())
						{
							left=w-left < $(window).width() ? (w-$(window).width()) : left-50;
							obj.style.left= -left+'px';					
						}
					
				obj.addEventListener('touchmove', function(event) {
				
					 
				  // Если 1 палец внутри элемента
				  if (event.targetTouches.length == 1) {
					var touch = event.targetTouches[0];
					// Place element where the finger is
					var dif=touch.pageX-starttouch;
					var newpos= startpos+dif;
					newpos= newpos < 0 ? (newpos < ($(window).width()-w) ? ($(window).width()-w) : newpos) : 0;
					//$('#menu').after("<div>"+newpos+": "+w+", newpos <(-w)"+(newpos<(-w))+"</div>")
					obj.style.left = newpos + 'px';
					//obj.style.top = touch.pageY + 'px';
				  }
				}, false);

		
				obj.addEventListener('touchstart', function(event) {
					console.log('touchmove');  
					  if (event.targetTouches.length == 1) {
						var touch = event.targetTouches[0];
						// Place element where the finger is
						starttouch = touch.pageX;
						startpos=obj.style.left ? parseInt(obj.style.left) : 0;
					  }
				}, false);
		
				$('a.mobile-back').click(function(){
					history.back();
					return false;
				})
				$('a.mobile-dropdown').click(function(){
					$(this).toggleClass('opened');
					$('#wrapper #menu').toggleClass('opened');
					
					/*
					if( $('#menu ul li').css('display')=='block' ){
						
					}
						else
					
					$('#menu ul li').css({
						'display':'block',
						'background-position':'-96px -168px'
					})
					*/
			
				})
			}
	
	}
})